import { isPlainObject } from "es-toolkit";
//#region ../erd-editor-schema/dist/dictionaryRows.js
var DictionaryFields = {
	wordEntities: [
		"id",
		"name",
		"abbreviation",
		"englishName",
		"description",
		"synonyms",
		"forbiddenWords"
	],
	termEntities: [
		"id",
		"name",
		"physicalName",
		"domainId",
		"description",
		"synonyms"
	],
	domainEntities: [
		"id",
		"name",
		"category",
		"dataType",
		"description"
	]
};
function withOrderKey(fields) {
	return [
		...fields.slice(0, 2),
		"order",
		...fields.slice(2)
	];
}
var RuntimeDictionaryFields = {
	wordEntities: withOrderKey(DictionaryFields.wordEntities),
	termEntities: withOrderKey(DictionaryFields.termEntities),
	domainEntities: withOrderKey(DictionaryFields.domainEntities)
};
var DictionaryKeyList = Object.keys(DictionaryFields);
var KEPT_VALUES = 2;
var isEmptyValue = (value) => value === "" || Array.isArray(value) && value.length === 0;
function toDictionaryRows(key, entities, fields = DictionaryFields[key]) {
	return {
		fields: [...fields],
		rows: entities.map((entity) => {
			const row = fields.map((field) => Reflect.get(entity, field));
			let end = row.length;
			while (end > KEPT_VALUES && isEmptyValue(row[end - 1])) end--;
			return row.slice(0, end);
		})
	};
}
function fromDictionaryRows(json) {
	if (!isPlainObject(json)) return [];
	const { fields, rows } = json;
	if (Array.isArray(fields) && Array.isArray(rows)) return rows.filter(Array.isArray).map((row) => Object.fromEntries(fields.slice(0, row.length).map((field, index) => [field, row[index]])));
	return Object.values(json).filter(isPlainObject);
}
var ROWS_PLACEHOLDER = /\n {6}"rows": \[\]/g;
var isDictionaryRows = (value) => isPlainObject(value) && Array.isArray(value.rows);
function stringifyDocument(source) {
	if (!source.collections) return JSON.stringify(source, null, 2);
	const blocks = [];
	const collections = { ...source.collections };
	for (const [key, collection] of Object.entries(collections)) {
		if (!DictionaryKeyList.includes(key) || !isDictionaryRows(collection)) continue;
		blocks.push(collection.rows);
		collections[key] = {
			...collection,
			rows: []
		};
	}
	let next = 0;
	return JSON.stringify({
		...source,
		collections
	}, null, 2).replace(ROWS_PLACEHOLDER, (placeholder) => {
		const rows = blocks[next++] ?? [];
		if (rows.length === 0) return placeholder;
		return `\n      "rows": [\n${rows.map((row) => `        ${JSON.stringify(row)}`).join(",\n")}\n      ]`;
	});
}
//#endregion
export { DictionaryFields, DictionaryKeyList, RuntimeDictionaryFields, fromDictionaryRows, stringifyDocument, toDictionaryRows };
